/**
 * Cities (Stammdaten-Städte) domain API functions.
 *
 * Read-only: the city list is a global reference table (migration 075), not
 * org data, and admins pick from it — they never write it.
 */
import { API_BASE_URL, getApiHeaders } from "./core";

/**
 * GET /api/admin/cities — the active cities, sorted by sort_order then name.
 *
 * The one reader of the one city endpoint. Each row carries `country_code`,
 * which is why a unit's `city_id` matters beyond display: it is the unit's
 * curated country source (see `derive_object_address` in the backend).
 */
export function fetchAdminCities() {
  return fetch(`${API_BASE_URL}/api/admin/cities`, { headers: getApiHeaders() }).then((res) => {
    if (!res.ok) throw new Error("Städte konnten nicht geladen werden.");
    return res.json();
  });
}
